import { action } from 'satcheljs';
/**
 * Launches PopupClose Action
 */
export default action('POPUP_CLOSED', function () {
    return {
        isOpen: false,
    };
});
//# sourceMappingURL=popupClosed.js.map